<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
      <vs-list>
        <vs-list-header title="Listen carefully and answer the questions." icon-pack="feather" icon="icon-info">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-header>
      </vs-list>

      <perfect-scrollbar>
        <vs-list class="inner-scroll-height">
          <vs-list-item v-for="(content, index) in contentList" class="msg-grp-container" 
            :key="index" 
            :title="content.translation" 
            :subtitle="content.sentence">
              <vs-button @click="onListen(index)">듣기</vs-button>
          </vs-list-item>
        </vs-list>
      </perfect-scrollbar>

      <div class="text-center">
        <audio ref="audioPlayer" 
            controls
            v-on:ended="audioFinish"
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    PerfectScrollbar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0
    }
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    }
  },
  methods: {
    onReload () {
      this.startAlert()
    },
    onStart () {
      //this.onComplete()
    },
    audioFinish () {
      
    },
    onListen (index) {
      if (this.studyFinished) return
      console.log(this.contentList[index].audio)
      this.audioPlayer.src = this.contentList[index].audio
      this.audioPlayer.play()
    },
    startAlert () {
      this.startStudyDlg('Listen carefully and answer the questions.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildCheckUpAudioPath(this.sourceContent.contentCode, contentJson.sentence[i])
      } 
      this.contentList.push(content)
    }
    console.log(this.contentList)
    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
}

</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
